import "@ant-design/v5-patch-for-react-19";

import * as Sentry from "@sentry/react";
import { PostHogProvider } from "@posthog/react";
import pl from "antd/es/locale/pl_PL";
import { NuqsAdapter } from "nuqs/adapters/react-router/v6";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./i18nextConfig";

import App from "./App";

import "./index.css";
// Po Tailwindzie: typografia odpowiedzi agentów (zasięg tylko `.chat-typeset`).
import "@fitness-app/web-ui/components/ai-elements/chat-typeset.css";

import { ConfigProvider } from "antd";
import dayjs from "dayjs";
import posthog from "posthog-js";
import { Provider } from "react-redux";

import { antdTheme } from "./antdTheme";
import { store } from "./store/initializeStore";
import { TRAINEE_STORE_ABORT_REASON } from "~/modules/Trainee/TraineeProfile/scope/traineeStoreAbortReason";

import("dayjs/locale/pl");
dayjs.locale("pl");

// Po wdrożeniu admina stare pliki `assets/*` znikają, a karta otwarta wcześniej
// dalej prosi o nie przy pierwszym leniwym imporcie (np. edytor pomocy) i biały
// ekran. Jedno odświeżenie ściąga nowy build; znacznik w sessionStorage nie
// pozwala wpaść w pętlę, gdy plik brakuje naprawdę.
window.addEventListener("vite:preloadError", (event) => {
  const RELOAD_KEY = "vite-preload-reload-at";
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
  } catch {
    // sessionStorage bywa zablokowany - wtedy bez automatycznego odświeżenia
    return;
  }
  if (Date.now() - last < 60_000) return;

  event.preventDefault();
  try {
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {
    return;
  }
  window.location.reload();
});

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_APP_ENV,
  release: `admin@${import.meta.env.PACKAGE_VERSION}`,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  sendDefaultPii: true,
  tracesSampleRate: 0.1,
  enabled: import.meta.env.PROD,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: import.meta.env.PROD ? 1 : 0,
  // Przerwanie odczytów buildera przy przełączaniu kart klientek jest zamierzone (TraineeStoreGate),
  // a komponenty, które łapią błąd zapytania, zgłaszałyby je jako błąd (ADMIN-WEB-APP-8D).
  beforeSend: (event, hint) => {
    const error = hint.originalException as { name?: string; message?: string } | null | undefined;
    if (error?.name === "AbortError" && error.message === TRAINEE_STORE_ABORT_REASON) {
      return null;
    }
    return event;
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <>
    <ConfigProvider locale={pl} theme={antdTheme}>
      <BrowserRouter>
        <NuqsAdapter>
          <Provider store={store}>
            <PostHogProvider client={posthog}>
              <App />
            </PostHogProvider>
          </Provider>
        </NuqsAdapter>
      </BrowserRouter>
    </ConfigProvider>
  </>,
);
